import { ClothesTypes } from "../models/clothes/clothes.model";

export const categoryLabels: Record<ClothesTypes, string> = {
    dress: "Fustan",
    pants: "Pantollona",
    shirt: "Maicë",
    "t-shirt": "Këmishë",
    blouse: "Bluzë",
    jumper: "Xhemper",
    jacket: "Jakne",
    bikini: "Bikini",
    pijamas: "Pixhame",
    suit: "Komplet",
    wedding: "Nusëri",
};

export const categoryList: ClothesTypes[] = [
    "dress", "pants", "shirt", "t-shirt", "blouse", "jumper", "jacket", "bikini", "pijamas", "suit", "wedding"
];
